<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12>
                <v-text-field
                    label="标题"
                    required
                    :rules="rules.required"
                    v-model="item.title"/>
              </v-flex>

              <v-flex xs9>
                <v-autocomplete
                    label="栏目"
                    clearable
                    required
                    :rules="rules.required"
                    v-model="item.sectionId"
                    item-text="name"
                    item-value="dbid"
                    :items="sectionItems"
                    @change="(nv, ov) => {
                    coverPhoto = (nv ? sectionItems.find(e => e.dbid === nv).coverPhoto : false);
                    if(!coverPhoto) {
                       item.coverPhoto = null
                    }
                   }"
                />
              </v-flex>

              <!--
              <v-flex xs4>
                <v-menu
                  ref="refPubDate"
                  :close-on-content-click="false"
                  v-model="menuPubDate"
                  :return-value.sync="item.pubDate"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="item.pubDate"
                    label="发布日期"
                    clearable
                    read-only
                    :rules="rules.pubDate"
                  />
                  <v-date-picker
                    v-model="item.pubDate"
                    locale="zh-cn"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="menuPubDate = false">取消</v-btn>
                    <v-btn flat color="primary" @click="$refs.refPubDate.save(item.pubDate)">确定</v-btn>
                  </v-date-picker>
                </v-menu>

              </v-flex>
              -->
              <v-flex xs3>
                <v-autocomplete
                    label="草稿"
                    required
                    :rules="rules.draft"
                    v-model="item.draft"
                    :items="[{value: true, text:'是'}, {value: false, text:'否'}]"
                />
              </v-flex>

              <v-flex xs12 :style="{display:coverPhoto? 'block': 'none'}">
                <x-single-uploader
                    label="封面图片"
                    :action="fileUri"
                    v-model="item.coverPhoto"
                    extensions="jpg,jpeg,png,gif"
                    accept="image/png,image/gif,image/jpeg"
                    :size="Number(0.5)"
                    hint="上传 jpg, jpeg, png 或 gif 图片，大小不超过 500K."
                >
                </x-single-uploader>
              </v-flex>

              <v-flex xs6>
                <v-text-field
                    label="关键词"
                    :rules="rules.normal"
                    v-model="item.keywords"/>
              </v-flex>

              <v-flex xs6>
                <v-text-field
                    label="来源"
                    :rules="rules.normal"
                    v-model="item.source"/>
              </v-flex>

              <!--<v-flex xs4 style="display: none">-->
              <!--<v-text-field-->
              <!--label="作者"-->
              <!--:rules="rules.normal"-->
              <!--v-model="item.author"-->
              <!--/>-->
              <!--</v-flex>-->

              <v-flex xs12>
                <ck-editor
                    v-model="item.content"
                ></ck-editor>
              </v-flex>

              <v-flex xs12>
                <v-checkbox
                    v-model="item.attchReqLogin"
                    label="下载附件需要登录系统"
                    false-value="F"
                    true-value="T"
                ></v-checkbox>
              </v-flex>

              <v-flex xs12>
                <x-uploader
                    label="附件列表"
                    :action="fileUri"
                    v-model="item.attachments"
                    :size="Number(100)"
                    description="附件大小不超过 100M."
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex'

import mixin from '@/mixin'
import CkEditor from '@/components/global/CkEditor'
import XUploader from '@/components/global/Uploader'
import XSingleUploader from '@/components/global/SingleUploader'

const baseUri = '/api/web/article';
const sectionUri = '/api/web/section';

export default {
  mixins: [mixin.edit(baseUri)],
  components: {CkEditor, XUploader, XSingleUploader},
  data() {
    return {
      fileUri: '/api/web/file',

      formValid: false,

      item: {
        "content": "",
        "coverPhoto": null,
      },
      freshItem: {
        "sectionId": null,
        "title": null,
        "keywords": null,
        "source": null,
        "author": null,
        "content": "",
        "pubDate": null,
        "draft": null,

        "coverPhoto": null
      },

      coverPhoto: false,

      menuPubDate: false,

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
        draft: [
          v => (v === true || v === false) || '必填项。'
        ],
        normal: [v => (!v || v.length <= 50) || '长度必须小于50个字符。']
      },

      sectionLoading: false,
      sectionItems: [],
    }
  },

  created() {
    this.sectionLoading = true;
    this.axios.get(sectionUri, {params: {limit: 65535, sort: 'rank.asc'}})
        .then(
            rsp => {
              this.sectionLoading = false;
              this.sectionItems = rsp.data.items.filter(v => v.identifier !== 'report');

              this.item.pubDate = new Date().toISOString();
            })
  },

  computed: {
    ...mapGetters([
      'name'
    ])
  },

  methods: {
    beforeSendData(data) {
      data.author = this.name
    }
  }
}
</script>
<style>
.ck-content .image {
  clear: both;
  text-align: center;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.ck-content .image > figcaption {
  color: #333;
  background-color: #f7f7f7;
  padding: .6em;
  font-size: 1em;
  outline-offset: -1px;
}
</style>
